import type { CandidateRowStatus } from '@features/csv-import/candidate-status.helpers';
import type { BlueprintCalibration } from '@shared/models/design/blueprint-underlay.model';

/** Import-tab statuses reused for blueprint calibration UI. */
export type BlueprintCalibrationUiStatus = Extract<
  CandidateRowStatus,
  'mapped' | 'incomplete'
>;

/**
 * Map calibration evidence to Import-tab status icons (`mapped` / `incomplete`).
 * Calibrated = primary known-length span exists.
 */
export const getBlueprintCalibrationUiStatus = (
  calibration: BlueprintCalibration | undefined,
): BlueprintCalibrationUiStatus =>
  calibration?.primary ? 'mapped' : 'incomplete';

/**
 * Short label next to the Import-style status icon.
 * Underlay scale state for the PDF panel (“Scale set” / “Scale not set”).
 */
export const getBlueprintCalibrationStatusLabel = (
  calibration: BlueprintCalibration | undefined,
): string => (calibration?.primary ? 'Scale set' : 'Scale not set');
